








import { Component, Prop, Mixins } from "vue-property-decorator";
import { IObject, instanceOfIFreeInputableObject } from "../objects";

@Component
export default class FixedPhraseMenu extends Mixins() {
  @Prop()
  source: IObject;

  @Prop()
  phrase: string;

  get shouldFreeInput(): boolean {
    return instanceOfIFreeInputableObject(this.source) && this.source.shouldInputFree;
  }

  get description(): string {
    return (this.shouldFreeInput ? "フリー入力にして" : "") + this.phrase + "を入力します。";
  }

  async overwrite(): Promise<void> {
    if (instanceOfIFreeInputableObject(this.source)) {
      this.source.overwriteText(this.phrase, true);
    }
  }
}
